import request from 'utils/request';
import { SSO_URL } from 'common/config';

/**
 * `isRetry` is set to true to avoid recursion when handling errors
 * @return {Promise}
 */
export const refreshAccessToken = () =>
  request.get(`${SSO_URL}/auth/refresh`, { isRetry: true });
